import styled from 'foundations-theming/utils';
import { StyledIconButton, StyledHandleButton } from 'layout-dnd-components/DndToolbar/styledButtons';
import { getIsUngatedForSCPWidgetEditor } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getWidgetElementImmutable, isInlineScpEditable as getIsInlineScpEditable
// @ts-expect-error not typed
} from 'InpageEditorUI/lib/inpage/utils';
import { BASE_RESPONSIVE_TOOLBAR_COLORS } from './constants';

// Need custom hashing function to memoize more than one argument. And even though
// `buildActionsFor*` may take more than N arguments, only the first N matter for
// memoization (the dispatch function and bus will always been the same)
import { jsx as _jsx } from "react/jsx-runtime";
export const hashFunctionForNArgs = n => {
  return (...args) => args.slice(0, n).join('-');
};
export const hashFunctionForObject = object => {
  return Object.keys(object).reduce((acc, key) => acc + key + object[key], '');
};
const wrapWithStyledHandle = (connectDragSource, StyledHandle) => ({
  handleButton
}) => {
  // Wrap styled component with connectDragSource if available
  const ref = connectDragSource ? divEl => connectDragSource(divEl) : undefined;
  return /*#__PURE__*/_jsx(StyledHandle, {
    ref: ref,
    children: handleButton
  });
};
export const wrapHandle = (connectDragSource, active, StyledHandle) => {
  if (active) {
    return wrapWithStyledHandle(connectDragSource, StyledHandle);
  }
  return connectDragSource ? ({
    handleButton
  }) => connectDragSource( /*#__PURE__*/_jsx("div", {
    children: handleButton
  })) : undefined;
};
export const styledIconButtonComponent = styled(StyledIconButton).withConfig({
  displayName: "helpers__styledIconButtonComponent",
  componentId: "sw16b0-0"
})([".hs-private.hs-private.hs-private &.uiButton.uiButton{border:none;border-top:1px solid ", ";border-bottom:1px solid ", ";border-right:1px solid ", ";}.hs-private.hs-private.hs-private &.uiButton.uiButton:hover{border:none;border-top:1px solid ", ";border-bottom:1px solid ", ";border-right:1px solid ", ";}"], props => props.active ? BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_ACTIVE : BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_INACTIVE, props => props.active ? BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_ACTIVE : BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_INACTIVE, props => props.active ? BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_ACTIVE : BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_INACTIVE, BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_HOVER, BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_HOVER, BASE_RESPONSIVE_TOOLBAR_COLORS.ICON_BUTTON_BORDER_HOVER);
export const styledHandleButtonComponent = styled(StyledHandleButton).withConfig({
  displayName: "helpers__styledHandleButtonComponent",
  componentId: "sw16b0-1"
})([".hs-private.hs-private.hs-private &.uiButton.uiButton{background-color:", ";border:none;border-bottom:1px solid ", ";color:", ";", "}.hs-private.hs-private.hs-private &.uiButton.uiButton:hover{border:none;border-bottom:1px solid ", ";}"], props => props.active ? BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_BACKGROUND_ACTIVE : BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_BACKGROUND_INACTIVE, props => props.active ? BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_BACKGROUND_ACTIVE : BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_BACKGROUND_INACTIVE, BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_TEXT_COLOR, props => props.draggable ? 'cursor: move;' : 'cursor: pointer;', BASE_RESPONSIVE_TOOLBAR_COLORS.HANDLE_BUTTON_BACKGROUND_ACTIVE);
export const getShouldNotOpenSidebarOnEditClick = (state, module) => {
  const isDataAuthoringModeActive = getIsDataAuthoringModeActive(state);
  const isUngatedForSCPWidgetEditor = getIsUngatedForSCPWidgetEditor(state);
  let isInlineScpEditable = false;
  if (isDataAuthoringModeActive && isUngatedForSCPWidgetEditor) {
    const {
      $widget
    } = getWidgetElementImmutable(module);
    isInlineScpEditable = getIsInlineScpEditable(module, $widget);
  }
  return isInlineScpEditable;
};